var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalysisFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      marginLeft: 4
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13435 0.49931C6.51925 -0.167357 7.4815 -0.167356 7.8664 0.49931L13.0626 9.49931C13.4475 10.166 12.9663 10.9993 12.1965 10.9993H1.80422C1.03442 10.9993 0.553298 10.166 0.938198 9.49931L6.13435 0.49931ZM6.00038 3.99931C6.00038 3.44703 6.44809 2.99931 7.00038 2.99931C7.55266 2.99931 8.00038 3.44703 8.00038 3.99931V5.99931C8.00038 6.5516 7.55266 6.99931 7.00038 6.99931C6.44809 6.99931 6.00038 6.5516 6.00038 5.99931V3.99931ZM7.00038 7.99931C6.44809 7.99931 6.00038 8.44703 6.00038 8.99931C6.00038 9.5516 6.44809 9.99931 7.00038 9.99931C7.55266 9.99931 8.00038 9.5516 8.00038 8.99931C8.00038 8.44703 7.55266 7.99931 7.00038 7.99931Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisFailed);
export default __webpack_public_path__ + "static/media/analysis-failed.5bb7d859.svg";
export { ForwardRef as ReactComponent };